import {tokens} from '@sail/ui';

type CountdownRingProps = {
  seconds: number;
  total: number;
  size?: number;
  strokeWidth?: number;
};

export const CountdownRing = ({
  seconds,
  total,
  size = 20,
  strokeWidth = 2,
}: CountdownRingProps) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = seconds / total;
  const offset = circumference * (1 - progress);

  return (
    <svg width={size} height={size} style={{flexShrink: 0}}>
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke={tokens.color.background.offset.toString()}
        strokeWidth={strokeWidth}
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke={tokens.color.feedback.success[400].toString()}
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
        style={{transition: 'stroke-dashoffset 1s linear'}}
      />
    </svg>
  );
};
